import React, { useEffect }  from "react";
import { connect } from "react-redux";
import RecruitmentOverviewTabs from "./components/OveriewTab";
import { 
    Users,
    UserPlus,
    TrendingUp,
    CheckCircle,
 } from "lucide-react";
import SummaryHeader from "components/header/SummaryHeader";
import SummaryItem from "components/header/SummaryItem";
import { getRecruitmentStat } from "../../../redux/recruitment/recruitmentState";

const RecruitmentOverview = ({recordStat, getStats}) => {

    useEffect(() => {
        getStats();
    }, [getStats]);

    return (
        <div className="grid grid-cols-1">
            <div className="space-y-6">
                <SummaryHeader
                    title={"Recruitment Overview"}
                    icon={Users}
                    description={"Track candidate progress and build your dream team"}
                    color={"green"}
                >
                    <div className="summary-item-container">
                        <SummaryItem
                            title="Active Candidates"
                            icon={<UserPlus />}
                            display={recordStat?.active_candidates || 0}
                        />
                        <SummaryItem
                            title="Avg. Time to Hire"
                            icon={<TrendingUp />}
                            display={`${recordStat?.average_time_to_hire || 0} days`} 
                        />
                        <SummaryItem
                            title="Offers Extended"
                            icon={<CheckCircle />}
                            display={recordStat?.offers_extended || 0} 
                        />
                    </div>
                </SummaryHeader>
                <RecruitmentOverviewTabs />
            </div>
        </div>
    );
};

const mapStateToProps = (state) => ({
    recordStat: state.recruitment.recruitmentStat?.data,
});

const mapDispatchToProps = (dispatch) => ({
    getStats: (data) => dispatch(getRecruitmentStat(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(RecruitmentOverview);